import { useState } from "react";

import * as styles from "styles/CommonDropdownStyles.module.scss";

import { ButtonContentTypes, ButtonTypes } from "constants/enumTypes.constants";
import { PAGE_IDENTIFIERS } from "common/constants";
import { clearExportFilters } from "common/utils/utils";
import { useAutoClearFilter } from "common/hooks/useAutoClearFitlers";

import DataPhaseDropdown from "./DataPhaseDropdown/DataPhaseDropdown";
import DateRangeFilter from "components/common/DateRangeFilter/DateRangeFilter";
import ExportTypeDropdown from "./ExportTypeDropdown/ExportTypeDropdown";
import PartnerDropdown from "components/common/PartnerDropdown/PartnerDropdown";
import Button from "components/common/Button/Button";

const CollapsibleFilterChildren = ({ searchOptions, setSearchOptions }) => {
  const [dataPhase, setDataPhase] = useState();
  const [exportType, setExportType] = useState();
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const pageIdentifier = PAGE_IDENTIFIERS.EXPORTS;
  const buttonTitle = "Clear Filter";

  /**
   * The function `clearFilters` clears all filters and search options for a given page identifier.
   *
   * @param pageIdentifier - The `pageIdentifier` parameter is used to identify the page for which the
   * exports filters are being cleared.
   */
  const clearFilters = (pageIdentifier) => {
    clearExportFilters(pageIdentifier);

    setSearchOptions({});
    setDataPhase();
    setExportType();
    setStartDate("");
    setEndDate("");
  };

  /* To automatically clear export filters for a given page identifier. */
  useAutoClearFilter(pageIdentifier, clearExportFilters);

  return (
    <div className="d-flex gap-4">
      <PartnerDropdown
        {...{
          selectedPartner: searchOptions?.partner,
          setSearchOptions,
          className: styles.Dropdown,
          pageIdentifier,
        }}
      />
      <DataPhaseDropdown
        {...{
          dataPhase,
          setDataPhase,
          setSearchOptions,
          className: styles.Dropdown,
          pageIdentifier,
        }}
      />
      <ExportTypeDropdown
        {...{
          exportType,
          setExportType,
          setSearchOptions,
          className: styles.Dropdown,
          pageIdentifier,
        }}
      />
      <DateRangeFilter
        {...{
          startDate,
          endDate,
          setStartDate,
          setEndDate,
          setSearchOptions,
          className: styles.Date_Picker,
          placeholder: "Created between",
          pageIdentifier,
        }}
      />
      <Button
        {...{
          buttonType: ButtonTypes.PRIMARY_SMALL,
          buttonContentType: ButtonContentTypes.TEXT,
          onClick: () => clearFilters(pageIdentifier),
          title: buttonTitle,
        }}>
        <span>{buttonTitle}</span>
      </Button>
    </div>
  );
};

export default CollapsibleFilterChildren;
